export default __webpack_public_path__ + "assets/models/630cfe7e8388bff5bfda6692ce4ca40b.glb";